define(
    'views/admin_advert_block.view',[
        'loader',
        'config',
        'helper',
        'sandbox',

        'text!templates/admin_advert_block.html'
    ],
    function(Loader, Config, Helper, Sandbox, advertBlockTemplate)
    {
        var $ = Loader.$;
        var _ = Loader._;

        var AdvertBlockView = Loader.Backbone.View.extend(
            {

                routes: {
                    "/admin_": "advert"
                },

                initialize: function()
                {
                    var _this = this;

                    this.model.on('startApplication', function(){
                        Helper.filterRoutes(_this.routes, _this);
                    });
                },

                advert: function()
                {
                    var compiledTemplate = _.template(
                        advertBlockTemplate,
                        {
                            model: this.model.toJSON()
                        }
                    );

                    this.$el.html(compiledTemplate);
                    return this;
                }
            });

        return {
            initialize: function(model)
            {
                return new AdvertBlockView({
                    el: $(".title-logo-tdr:first"),
                    model: model
                })
            }
        }
    }
);
